import React from "react";
import { convertTime } from "../helperFunctions/helperFunctions";

export default function TitleSection({
  subreddit,
  author,
  created,
  title,
  handleShow,
}) {
  return (
    <div className="card-text-container">
      <p className="card-small-text fw-light">
        {subreddit} · {author} · {convertTime(created)} ago
      </p>
      <p className="card-title" onClick={handleShow}>
        {title}
      </p>
    </div>
  );
}
